
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"active-highlight",attrs:{"d":"M392.234 261.988c-66.039 0-119.766 53.727-119.766 119.766S326.195 501.52 392.234 501.52 512 447.793 512 381.754s-53.727-119.766-119.766-119.766zM312.39 381.754c0-44.026 35.818-79.844 79.844-79.844a79.335 79.335 0 0138.749 10.066L322.456 420.504a79.342 79.342 0 01-10.066-38.75zm79.844 79.844c-15.513 0-29.996-4.462-42.263-12.148L459.93 339.491c7.686 12.266 12.148 26.75 12.148 42.263 0 44.026-35.818 79.844-79.844 79.844z","fill":"#E2E4EC"}}),_c('path',{staticClass:"disabled-highlight",attrs:{"d":"M228.554 441.637H79.844c-22.013 0-39.922-17.909-39.922-39.922V131.244H471.08v101.801c0 11.024 8.937 19.961 19.961 19.961s19.961-8.937 19.961-19.961V70.363c0-33.019-26.864-59.883-59.883-59.883H59.883C26.864 10.48 0 37.343 0 70.363v331.353c0 44.026 35.818 79.844 79.844 79.844h148.71c11.024 0 19.961-8.937 19.961-19.961s-8.937-19.962-19.961-19.962zM450.121 50.402c11.007 0 19.961 8.955 19.961 19.961 0 11.007-8.954 19.961-19.961 19.961s-19.961-8.955-19.961-19.961c0-11.007 8.954-19.961 19.961-19.961zm-79.844 0c11.007 0 19.961 8.955 19.961 19.961 0 11.007-8.954 19.961-19.961 19.961s-19.961-8.955-19.961-19.961c0-11.007 8.954-19.961 19.961-19.961zM39.922 70.363c0-11.006 8.954-19.961 19.961-19.961h253.944a59.596 59.596 0 00-3.433 19.961 59.555 59.555 0 003.794 20.959H39.922V70.363z"}})])
          )
        }
      }
    